import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import FooterContactForm from "../components/FooterContactForm";
import { usePageMeta, ORG_JSON_LD } from "../lib/usePageMeta";
import { CONTACT } from "../lib/site-data";
import { MapPin, Mail, MessageCircle, Clock } from "lucide-react";

const META = {
  seo: {
    title: "Contact CV Folks · UK CV Writing Service",
    description:
      "Get in touch with the CV Folks team. WhatsApp, email or use our contact form — we typically reply within a few hours during UK working days.",
    keywords: "contact cv folks, uk cv writer contact",
  },
  jsonLd: ORG_JSON_LD,
};

export default function ContactPage() {
  usePageMeta(META);
  const waPhone = (CONTACT.whatsappRaw || "447448457089").replace(/\D/g, "");
  return (
    <>
      <Navbar />
      <main data-testid="contact-page" className="pt-24 md:pt-32 bg-background pb-24">
        <div className="max-w-6xl mx-auto px-6 md:px-10">
          <p className="label-eyebrow">Contact</p>
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold mt-3 leading-[1.05] max-w-3xl">
            Let&apos;s talk about your next role.
          </h1>
          <p className="text-base md:text-lg text-foreground/70 mt-5 max-w-2xl">
            Have a question about a package, need a rush turnaround, or want a
            second opinion on your CV? Drop us a line — we typically reply within
            a few hours during UK working days.
          </p>

          <div className="mt-14 grid md:grid-cols-[minmax(0,1fr)_320px] gap-10">
            <div>
              <FooterContactForm variant="light" />
            </div>
            <aside className="space-y-4">
              <div
                data-testid="contact-detail-whatsapp"
                className="rounded-2xl border border-border bg-card p-5"
              >
                <div className="flex items-center gap-2 text-brand">
                  <MessageCircle className="h-4 w-4" />
                  <span className="text-xs font-bold uppercase tracking-widest">
                    WhatsApp
                  </span>
                </div>
                <a
                  href={`https://wa.me/${waPhone}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-2 block font-semibold text-foreground hover:text-brand"
                >
                  {CONTACT.whatsapp || "+44 7448 457089"}
                </a>
                <p className="text-sm text-foreground/60 mt-1">Fastest response.</p>
              </div>

              <div className="rounded-2xl border border-border bg-card p-5">
                <div className="flex items-center gap-2 text-brand">
                  <Mail className="h-4 w-4" />
                  <span className="text-xs font-bold uppercase tracking-widest">
                    Email
                  </span>
                </div>
                <a
                  href={`mailto:${CONTACT.email || "cvfolksbritain@gmail.com"}`}
                  className="mt-2 block font-semibold text-foreground hover:text-brand break-all"
                >
                  {CONTACT.email || "cvfolksbritain@gmail.com"}
                </a>
              </div>

              <div className="rounded-2xl border border-border bg-card p-5">
                <div className="flex items-center gap-2 text-brand">
                  <MapPin className="h-4 w-4" />
                  <span className="text-xs font-bold uppercase tracking-widest">
                    Studio
                  </span>
                </div>
                <p className="mt-2 font-semibold text-foreground">
                  {CONTACT.address || "354 Gray's Inn Rd, London WC1X 8BP"}
                </p>
                <p className="text-sm text-foreground/60 mt-1">Remote-first, UK-wide.</p>
              </div>

              <div className="rounded-2xl border border-border bg-card p-5">
                <div className="flex items-center gap-2 text-brand">
                  <Clock className="h-4 w-4" />
                  <span className="text-xs font-bold uppercase tracking-widest">
                    Hours
                  </span>
                </div>
                <p className="mt-2 text-sm text-foreground/80">
                  Mon–Fri · 9am–7pm UK<br />
                  Weekends · rush jobs only
                </p>
              </div>
            </aside>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
